import H from 'constants/httpMethod.const';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beSalonSetupSupported'); // eslint-disable-line no-unused-vars

export const beSalonSetupSupportedRead = actionEndpointBe('beSalonSetupSupportedRead', H.get, 'salon/setup/supported/', (options) => ({
  ...options,
  inert: true,
  pin: false, // NOTE: to allow PIN unsafe requests
  fromDto: fromDtoToSalonSetupSupported,
}));

export const fromDtoToSalonSetupSupported = (dto) => {
  if (!dto) return { countries: [] };

  const countries = asArray(Object.entries(dto)).map(([code, data]) => ({
    code, // GB, US, AE
    countryLabel: fromAnyToTrimmed(data.country_label || code),
    currency: fromAnyToTrimmed(data.currency),
    defaultLanguage: fromAnyToTrimmed(data.default_language),
    supportedTimezones: asArray(data.supported_timezones),
  }));

  return { countries };
};
